import { createRoot } from "react-dom/client";
import App from "./App";
import AuthGate from "./components/AuthGate";
import ErrorBoundary from "./components/ErrorBoundary";
import { ConfirmProvider } from "./components/ConfirmDialog";
import { ToastProvider } from "./components/Toast";
import "./index.css";
import "./devhub/devhub.css";

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <ToastProvider>
      <ConfirmProvider>
        <AuthGate>
          <App />
        </AuthGate>
      </ConfirmProvider>
    </ToastProvider>
  </ErrorBoundary>,
);
